import axios from 'axios'
import { ALTERAR_VEICULO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function alterarVeiculo (veiculo) {
  const url = `${URL}/veiculo/alterar`;
  return dispatch => axios.post(url, veiculo, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type:ALTERAR_VEICULO ,
        payload: response
      })
  );
}
